// src/components/utilComponents/CookiesChecker/CookiesErrorContent.tsx
import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';

import { palette, shape } from '@app/theme';
import { IconCollection } from '@components/icons/iconCollection';


export const CookiesErrorContent: React.FC = () => {
  return (
    <Box sx={{ padding: 1 }}>
      <Typography variant="body1" gutterBottom>
        Для корректной работы сайта необходимо включить поддержку cookies в
        вашем браузере.
      </Typography>
      
      <Typography variant="body1" gutterBottom sx={{ mt: 2 }}>
        Как включить cookies:
      </Typography>
      
      <List>
        <ListItem>
          <ListItemIcon>
            <FontAwesomeIcon icon={IconCollection.circleCheck} color="primary" />
          </ListItemIcon>
          <ListItemText primary="Откройте настройки вашего браузера" />
        </ListItem>
        
        <ListItem>
          <ListItemIcon>
            <FontAwesomeIcon icon={IconCollection.circleCheck} color="primary" />
          </ListItemIcon>
          <ListItemText
            primary="Найдите раздел 'Конфиденциальность' или 'Приватность'" />
        </ListItem>
        
        <ListItem>
          <ListItemIcon>
            <FontAwesomeIcon icon={IconCollection.circleCheck} color="primary" />
          </ListItemIcon>
          <ListItemText
            primary="Разрешите использование cookies для этого сайта" />
        </ListItem>
        
        <ListItem>
          <ListItemIcon>
            <FontAwesomeIcon icon={IconCollection.circleCheck} color="primary" />
          </ListItemIcon>
          <ListItemText
            primary="Перезагрузите страницу после изменения настроек" />
        </ListItem>
      </List>
      
      <Box sx={{
        mt: 2,
        display: 'flex',
        alignItems: 'center',
        backgroundColor: palette.warning.light,
        p: 2,
        borderRadius: `${shape.smallRadius}px`,
      }}>
        <FontAwesomeIcon icon={IconCollection.circleExclamation} style={{ marginRight: '8px', color: 'var(--mui-palette-warning-main)' }} />
        <Typography variant="body2">
          Без поддержки cookies некоторые функции сайта будут недоступны,
          включая авторизацию и сохранение ваших настроек.
        </Typography>
      </Box>
    </Box>
  );
};
